<template>
  <div>
    <h1>404</h1>
    <pre>route not found</pre>
    <router-link :to="{name: 'home'}">
      Home
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Login',
}
</script>
